import { connect } from 'react-redux';

import {
    MarketerProductsCell,
    MarketerProductsCellProps
} from '../../components/MarketerProductsCell/MarketerProductsCell';
import { MarketerProduct } from '../../typings/marketers';
import { State } from '../../typings/state';

interface OwnProps {
    products: MarketerProduct[];
}

type StateProps = MarketerProductsCellProps;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => ({
    products: ownProps.products,
    places: state.internalProductPlaces.places.reduce<Map<number, string>>((acc, place) => {
        acc.set(place.id, place.fullDescription);

        return acc;
    }, new Map<number, string>())
});

export const MarketerProductsCellContainer = connect<StateProps, null, OwnProps>(mapStateToProps)(MarketerProductsCell);
